"use strict";

import objectFitVideos from '/../../main/node_modules/object-fit-videos';
import objectFitImages from '/../../main/node_modules/object-fit-images';

const DefaultApp = () => {
    const init = () => {
        $(document).ready(function() {
            // WebP background image fallback swap
            const checkWebp = function () {
                if (!Modernizr.webp) {
                    let $elements = $('*[data-webp-bg-fallback]');
                    $elements.each(function() {
                        let fallback = $(this).data('webp-bg-fallback');
                        $(this).css('background-image', 'url(' + fallback + ')');
                    });

                    // Update img's with fallback
                    let $images = $('*[data-webp-img-fallback]');
                    $images.each(function() {
                        let fallback =  $(this).data('webp-img-fallback');
                        $(this).attr('src', fallback);
                        // Remove srcset if it cant handel webP as the srcset links are the webP images and breaks for Safari
                        $(this).removeAttr('srcset');
                    });
                }
            };

            $(document).on('ajaxUpdate', function(event, context) {
                checkWebp();
            });
            checkWebp();

            $('html').addClass('ready');
        });

        window.showStepOne = function(button){
            var module_wrapper = button.parents('.js-quote-form-container');

            module_wrapper.find('.js-quote-form-step-two').stop().slideUp(600, function() {
                module_wrapper.find('.js-quote-form-step-three').stop().slideUp(600, function() {
                    module_wrapper.find('.js-quote-form-step-one').stop().slideDown(600, function() {
                        if(module_wrapper.find('.js-quote-form-inner-container').length) {
                            module_wrapper.find('.js-quote-form-inner-container').height(module_wrapper.find('.js-quote-form-step-one').outerHeight() + 100);
                        }
                    });
                    module_wrapper.find('.js-step-one-nav').removeClass('disabled');
                    module_wrapper.find('.js-step-two-nav').addClass('disabled');
                    module_wrapper.find('.js-step-three-nav').addClass('disabled');
                    module_wrapper.find('.js-quote-form-nav').removeClass('disabled');
                });
            });
        }

        window.showStepTwo = function(form){
            var module_wrapper = form.parents('.js-quote-form-container');

            module_wrapper.find('.js-quote-form-step-one').stop().slideUp(600, function() {
                module_wrapper.find('.js-quote-form-step-three').stop().slideUp(600, function() {
                    module_wrapper.find('.js-quote-form-step-two').stop().slideDown(600, function() {
                        if(module_wrapper.find('.js-quote-form-inner-container').length) {
                            module_wrapper.find('.js-quote-form-inner-container').height(module_wrapper.find('.js-quote-form-step-two').outerHeight() + 100);
                        }
                    });
                    module_wrapper.find('.js-step-two-nav').removeClass('disabled');
                    module_wrapper.find('.js-step-one-nav').addClass('disabled');
                    module_wrapper.find('.js-step-three-nav').addClass('disabled');
                    module_wrapper.find('.js-quote-form-nav').removeClass('disabled');
                });
            });
            formStepChangeShared(form);

            // Back up code to copy over form fields as they sometimes dont copy over
            module_wrapper.find('.js-quote-form-step-one').find('.js-copy-value').each(function() {
                var form_two_field = module_wrapper.find('.js-quote-form-step-two').find("[name='" + $(this).attr('name') + "']");

                // .val() is undefined when step two has no matching field, so check the
                // match exists before reading its length
                if(form_two_field.length && !form_two_field.val()) {
                    form_two_field.val($(this).val());
                }
            });

        }

        window.showStepThree = function(form){
            var module_wrapper = form.parents('.js-quote-form-container');

            module_wrapper.find('.js-quote-form-step-two').stop().slideUp(600, function() {
                module_wrapper.find('.js-quote-form-step-one').stop().slideUp(600, function() {
                    module_wrapper.find('.js-quote-form-step-three').stop().slideDown(600, function() {
                        if(module_wrapper.find('.js-quote-form-inner-container').length) {
                            module_wrapper.find('.js-quote-form-inner-container').height(module_wrapper.find('.js-quote-form-step-three').outerHeight() + 100);
                        }
                    });
                    module_wrapper.find('.js-step-three-nav').removeClass('disabled');
                    module_wrapper.find('.js-step-two-nav').addClass('disabled');
                    module_wrapper.find('.js-step-one-nav').addClass('disabled');
                    module_wrapper.find('.js-quote-form-nav').addClass('disabled');
                });
            });
            formStepChangeShared(form);
        }

        window.formStepChangeShared = function(form){
            form.find('.alert-danger').removeClass('show');
            form.find('.alert-success').removeClass('show');
            if($(window).scrollTop() > 0) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: form.offset().top - 150
                }, 200);
            }
        }

        // Sets inputs as filled when Google autocomplete prefills them
        $(window).on('load', function() {
            $('input:-webkit-autofill').each(function(){
                $(this).parents('.form-group').addClass('focused filled');
            });
        });

        objectFitVideos();
        objectFitImages('img');

        $.fn.hasAttr = function(name) {
            return this.attr(name) !== undefined;
        };

        // Add selector to get all focusable elements
        $.expr[':'].focusable = function (element, hasTabindex) {
            var map, mapName, img, focusableIfVisible, fieldset,
                nodeName = element.nodeName.toLowerCase();

            if ( "area" === nodeName ) {
                map = element.parentNode;
                mapName = map.name;
                if ( !element.href || !mapName || map.nodeName.toLowerCase() !== "map" ) {
                    return false;
                }
                img = $( "img[usemap='#" + mapName + "']" );
                return img.length > 0 && img.is( ":visible" );
            }

            if ( /^(input|select|textarea|button|object)$/.test( nodeName ) ) {
                focusableIfVisible = !element.disabled;

                if ( focusableIfVisible ) {

                    // Form controls within a disabled fieldset are disabled.
                    // However, controls within the fieldset's legend do not get disabled.
                    // Since controls generally aren't placed inside legends, we skip
                    // this portion of the check.
                    fieldset = $( element ).closest( "fieldset" )[ 0 ];
                    if ( fieldset ) {
                        focusableIfVisible = !fieldset.disabled;
                    }
                }
            } else if ( "a" === nodeName ) {
                focusableIfVisible = element.href || hasTabindex;
            } else {
                focusableIfVisible = hasTabindex;
            }

            return focusableIfVisible && $( element ).is( ":visible" );
        }
    };

    return {
        init: init
    };
};

export default DefaultApp;